import SearchWithButton from "./SearchWithButton";

const StaffTableHeader = ({
  title,
  count = 0,
  searchTerm,
  setSearchTerm,
  buttons = [],
  onButtonAddButtonClick,
}) => {
  return (
    <div className="flex flex-col md:flex-row md:justify-between md:items-center mb-4 gap-4">
      <h2 className="text-lg font-semibold text-gray-700 flex items-center">
        {title}
        <span className="text-gray-400 text-sm ml-2">({count})</span>
      </h2>

      <div className="flex flex-col md:flex-row gap-2 items-center">
        <SearchWithButton
          placeholder={`Search ${title.toLowerCase()}...`}
          searchTerm={searchTerm}
          setSearchTerm={setSearchTerm}
          onButtonClick={onButtonAddButtonClick}
          buttonLabel="Add Staff"
        />

        {buttons.map((btn, index) => (
          <button
            key={index}
            onClick={btn.onClick}
            className="bg-primary hover:bg-primary/90 text-white text-sm px-4 py-2 rounded-md shadow-sm transition"
          >
            {btn.label}
          </button>
        ))}
      </div>
    </div>
  );
};

export default StaffTableHeader;
